export default import.meta.ROLLDOWN_FILE_URL_pmk$0iPswIZHmViN3BCfGQ